import { useAppContext } from "@contexts/Context";
import { estimate_data } from "@datas/estimate";
import { Box, Button, Grid, Typography } from "@material-ui/core";
import { colors } from "@theme";
import { useBreakpoints } from "@utils/breakpoints";
import { restoreUTMFromLocalStorage } from "@utils/utmHandler";
import React from "react";

export const EstimatePage = () => {
  const { isLessThanMd, isSm } = useBreakpoints();

  const { handleChangeTitleAndTag } = useAppContext();

  React.useEffect(() => {
    handleChangeTitleAndTag({
      title: "Swyft Energy | Instant Online Boiler and Solar Estimate",
      meta: "Generate Your Own Clean, Green,Renewable Electricity or Replacement Boiler Quotes in Seconds & Save On Your Energy Bills",
    });
  }, []);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleClickButton = (link: string) => {
    if (!link) {
      return;
    }
    let finalLink = link;
    if (
      link.includes("https://swyft.swyftenergy.ie/questionnaire") 
    ) {
      const utmParams = restoreUTMFromLocalStorage();
      if (utmParams && Object.keys(utmParams).length > 0) {
        const url = new URL(link);
        Object.entries(utmParams).forEach(([key, value]) => {
          url.searchParams.set(key, value);
        });
        finalLink = url.toString(); 
      }
    }
    window.open(finalLink, "_blank")?.focus();
  };

  return (
    <Box width="100%" height="100%">
      <Box mt={20} />
      <Box textAlign="center" mb={6}>
        <Typography variant={isLessThanMd ? "h4" : "h2"} color="secondary">
          Choose your service
        </Typography>
        <Box mt={2} mb={{ xs: 2, md: 4 }}>
          <Typography variant={isLessThanMd ? "body2" : "h5"}>Get your free online estimate in seconds</Typography>
        </Box>
      </Box>
      <Box mb={6} className="box-container">
        <Grid container>
          <Grid item xs={1} lg={2} xl={3} />
          <Grid item xs={10} lg={8} xl={6}>
            <Grid container spacing={3}>
              {estimate_data.map((data, index) => (
                <Grid item xs={12} md={6} key={index}>
                  <Box
                    bgcolor={colors.grey[200]}
                    borderRadius={22}
                    height="100%"
                    padding={4}
                    display="flex"
                    flexDirection={{ xs: "column", sm: "row", md: "column" }}
                    justifyContent="center"
                    alignItems="center"
                    mx="auto"
                    flexWrap="wrap"
                  >
                    <Box mb={4} height={150} width={{ xs: "100%", sm: "50%", md: "100%" }}>
                      <img loading="lazy" src={data.src} className={`h-full ${isSm ? "" : "mx-auto"}`} />
                    </Box>
                    <Box textAlign="center" mb={4} width={{ xs: "100%", sm: "50%", md: "100%" }}>
                      <Typography variant={isLessThanMd ? "h4" : "h3"} color="secondary">
                        {data.title}
                      </Typography>
                      <Box mt={2}sx={{ color: "#00306a" }}>
                        <Typography variant={isLessThanMd ? "h4" : "h5"} color="inherit">
                        {data.content}
                        </Typography>
                      </Box>
                    </Box>
                    <Box mt={"auto"} ml={isSm ? "auto" : "initial"}>
                      <Button variant="contained" color="primary" onClick={() => handleClickButton(data.link)}>
                        Get Estimate
                      </Button>
                    </Box>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
